export default __webpack_public_path__ + "static/media/loss-analysis-step-1.06497228.gif";